/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.metadataItems').factory('MetadataItemsViewDataTransformerFactory', function (
    uiGridConstants: JS5Object
) {
	return {
		packageColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
			},
			{
				field: 'displayIndex',
				displayName: '#',
				width: 60,
				type: 'number',
				sort: {
					direction: uiGridConstants.ASC,
					priority: 0
				},
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'displayName',
				width: '20%',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'ownersString',
				width: '10%',
				displayName: 'Type',
				enableSorting: false
			},
			{
				field: 'requiredLongSeason',
				displayName: 'Long Form Season',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortSeason',
				displayName: 'Short Form Season',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredLongVolume',
				displayName: 'Long Form Volume',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortVolume',
				displayName: 'Short Form Volume',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredLongMovie',
				displayName: 'Long Form Movie',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortMovie',
				displayName: 'Short Form Movie',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredAdPreRoll',
				displayName: 'Ad/Preroll',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			}
		],
		nonPackageColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
			},
			{
				field: 'displayIndex',
				displayName: '#',
				width: 60,
				type: 'number',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'displayName',
				width: '20%',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'ownersString',
				displayName: 'Type',
				type: 'string',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
				sort: {
					direction: uiGridConstants.ASC,
					priority: 0
				}
			},
			{
				field: 'uiControlHint',
				displayName: 'Component',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			}
		],
        conversionColumns: [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableColumnMenu: false,
                enableSorting: false,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/check-mark-template.html',
                headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
            },
            {
                field: 'displayIndex',
                displayName: '#',
                width: 60,
                type: 'number',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'displayName',
                width: '50%',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            },
            {
                field: 'uiControlHint',
                displayName: 'Component',
                sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
            }
        ],
		partnerColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
			},
			{
				field: 'displayIndex',
				displayName: '#',
				width: 60,
				type: 'number',
				sort: {
					direction: uiGridConstants.ASC,
					priority: 0
				},
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'displayName',
				width: '20%',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'requiredLongSeason',
				displayName: 'Long Form Season',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortSeason',
				displayName: 'Short Form Season',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredLongVolume',
				displayName: 'Long Form Volume',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortVolume',
				displayName: 'Short Form Volume',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredLongMovie',
				displayName: 'Long Form Movie',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredShortMovie',
				displayName: 'Short Form Movie',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			},
			{
				field: 'requiredAdPreRoll',
				displayName: 'Ad/Preroll',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			}
		],
		mvpdColumns: [
			{
				name: 'checkMarkRowHeaderCol',
				field: 'checkMark',
				width: 30,
				enableColumnMenu: false,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'components/visual/grid/check-mark-template.html',
				headerCellTemplate: 'system/metadata/searchView/cellTemplates/header-check-mark-template.html'
			},
			{
				field: 'displayIndex',
				displayName: '#',
				width: 60,
				type: 'number',
				sort: {
					direction: uiGridConstants.ASC,
					priority: 0
				},
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'displayName',
				width: '20%',
				sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC]
			},
			{
				field: 'required',
				displayName: 'Required',
				cellTemplate: 'system/metadata/searchView/cellTemplates/metadata-items-checkbox-cell-template.html',
				enableSorting: false
			}
		]
	};
});
